module.exports = __webpack_public_path__ + "img/img-18-2.96691a2c.png";